const Index = () => import('./index.vue');

export default [
    {
        path: '/general-settings',
        name: 'GeneralSettingsPage',
        component: Index
    }
];


